export default __webpack_public_path__ + "static/icare-logo-522f028ff580dba899238066c239aa59.png";